import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../../utils/models/workflow.model';

@Pipe({
  name: 'workflowStatus',
})
export class WorkflowStatusPipe implements PipeTransform {
  transform(value: number, statuses: Status[]): string {
    if (value && statuses?.length > 0) {
      let foundStatus = statuses.find(s => s.id === value);
      if (foundStatus) {
        return foundStatus?.label;
      }
    }
    return '';
  }
}
